import _implicitStylesheets from "./headerMenu.css";
import _implicitScopedStylesheets from "./headerMenu.scoped.css?scoped=true";
import _appxHeaderMenuItem from "appx/headerMenuItem";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<img${"a0:src"} width="42" height="42"${"a0:alt"}${"c0"}${"a0:aria-controls"}${"a0:aria-expanded"} aria-haspopup="true" role="button" data-menu="trigger"${"a0:aria-label"} tabindex="0"${2}>`;
const $fragment2 = parseFragment`<div${"c0"}${2}></div>`;
const stc0 = {
  classMap: {
    "menu-container": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "slds-grid": true,
    "menu": true
  },
  key: 6
};
const stc2 = {
  "menu-item": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, gid: api_scoped_id, b: api_bind, sp: api_static_part, st: api_static_fragment, k: api_key, c: api_custom_element, i: api_iterator, h: api_element} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7} = $ctx;
  return [api_element("div", stc0, [api_static_fragment($fragment1, 2, [api_static_part(0, {
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.toggleMenu)),
      "keydown": _m3 || ($ctx._m3 = api_bind($cmp.handleTriggerKeyDown))
    },
    className: api_normalize_class_name($cmp.menuTriggerClassName),
    attrs: {
      "src": $cmp.imageUrl,
      "alt": $cmp.imageAlt,
      "aria-controls": api_scoped_id("menu"),
      "aria-expanded": $cmp.menuExpanded,
      "aria-label": $cmp.menuName
    }
  }, null)]), api_static_fragment($fragment2, 4, [api_static_part(0, {
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.toggleMenu))
    },
    className: api_normalize_class_name($cmp.backDropClassName)
  }, null)]), api_element("div", {
    className: api_normalize_class_name($cmp.menuClassName),
    attrs: {
      "data-menu": "menu",
      "id": api_scoped_id("menu"),
      "tabindex": "0",
      "role": "menu",
      "aria-label": $cmp.menuName
    },
    key: 5,
    on: {
      "keydown": _m6 || ($ctx._m6 = api_bind($cmp.handleMenuKeyDown))
    }
  }, [api_element("div", stc1, api_iterator($cmp._menuItems, function (itValue, itIndex, itFirst, itLast) {
    const it = {
      value: itValue,
      index: itIndex,
      first: itFirst,
      last: itLast
    };
    return api_custom_element("appx-header-menu-item", _appxHeaderMenuItem, {
      classMap: stc2,
      props: {
        "props": it.value
      },
      key: api_key(7, it.value.position),
      on: {
        "toggle": _m7 || ($ctx._m7 = api_bind($cmp.toggleMenu))
      }
    });
  }))])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1fmqgkqdnt4";
tmpl.legacyStylesheetToken = "appx-headerMenu_headerMenu";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
